import styled from '@emotion/styled';
import { Button, breakpoint, colors, spacing, typography } from 'component-library';

export const FormWrapper = styled.div`
  flex-grow: 1;
  background: ${colors.secondary.beigeTint1};
  padding: ${spacing.large} ${spacing.mediumLow} ${spacing.xxlarge} 0;

  @media (max-width: ${breakpoint.xlarge + 96}px) {
    padding-left: ${spacing.mediumHigh};
    padding-right: ${spacing.mediumHigh};
  }
`;

export const SummaryWrapper = styled.div`
  width: 38%;
  padding: ${spacing.mediumHigh} ${spacing.mediumHigh} ${spacing.mediumHigh} ${spacing.mediumHigh};
`;

export const CheckoutWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const DesktopHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${spacing.medium};
`;
export const MobileHeaderContainer = styled.div`
  width: 100%;
  display: none;
`;

export const SpaceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.small};
`;

export const StepContainer = styled.div`
  position: relative;
`;

export const StyledContainer = styled.div`
  background: linear-gradient(
    to right,
    ${() => colors.secondary.beigeTint1} 0%,
    ${() => colors.secondary.beigeTint1} 50%,
    ${() => colors.base.white} 50%,
    ${() => colors.base.white} 100%
  );
  height: 100%;
  bottom: 0;

  & ${FormWrapper} {
    min-height: calc(
      100vh - 72px - 56px - 107px - 48px
    ); //Reduce from 100vh the height of the header and footer
  }

  // Mobile
  @media (max-width: ${breakpoint.medium}px) {
    background: ${colors.secondary.beigeTint1};

    & ${CheckoutWrapper} {
      display: flex;
      flex-direction: column;
      padding: 0px;
    }

    & ${CheckoutWrapper} > div {
      width: 100%;
    }

    & ${FormWrapper}, & ${SummaryWrapper} {
      margin: 0;
    }

    & ${FormWrapper} {
      order: 3;
      min-height: auto;
      padding-top: 0;
    }

    & ${SummaryWrapper} {
      padding: ${spacing.large};
      background: ${colors.base.white};
      margin-bottom: ${spacing.mediumHigh};
      order: 2;
      width: 100%;
    }

    & ${DesktopHeaderContainer} {
      display: none;
    }

    & ${MobileHeaderContainer} {
      display: block;
      padding: ${spacing.mediumHigh} ${spacing.large};
      order: 1;
    }
  }

  @media (max-width: ${breakpoint.small}px) {
    background: ${colors.base.white};

    & ${FormWrapper} {
      border-top: 2px solid ${colors.monochrome.grey20};
      padding: ${spacing.mediumLow} ${spacing.small} ${spacing.xxlarge} ${spacing.small};
      order: 3;
      background: ${colors.base.white};
    }

    & ${MobileHeaderContainer} {
      display: block;
      padding: ${spacing.small};
      order: 1;
      background: ${colors.secondary.beigeTint1};
    }

    & ${SpaceWrapper} {
      margin-left: -${spacing.small};
      margin-right: -${spacing.small};
    }

    & ${SummaryWrapper} {
      padding: ${spacing.mediumLow} ${spacing.small} 0 ${spacing.small};
      background: ${colors.base.white};
      order: 2;
      width: 100%;
    }

    & ${StepContainer} {
      padding-top: ${spacing.mediumLow};
    }

    & ${StepContainer}::before {
      content: '';
      position: absolute;
      top: 0;
      left: -24px;
      width: 115%;
      border-top: 2px solid ${colors.monochrome.grey20};
    }
  }
`;

export const ButtonBar = styled.div`
  display: flex;
  justify-content: flex-start;

  & > button:first-of-type {
    margin: 0 ${spacing.mediumLow};
  }
`;

export const ButtonBarV2 = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column-reverse;
  align-items: center;

  @media (min-width: ${breakpoint.small}px) {
    &:has(button:only-child) {
      justify-content: flex-end;
      flex-direction: row;
    }
  }

  @media (min-width: ${breakpoint.large}px) {
    justify-content: space-between;
    flex-direction: row;
    align-items: flex-end;

    &:has(button:only-child) {
      justify-content: flex-end;
    }
  }
`;

export const PreviousButton = styled(Button)`
  padding: ${spacing.xmsmall} 0;
`;

export const ButtonHelperText = styled.div`
  ${typography.body.medium};
  display: flex;
  flex-direction: column;
  color: ${colors.primary.grey};

  & > span {
    margin-bottom: ${spacing.xxsmall};
    text-align: center;
  }
`;

export const FinalButtonBar = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: ${spacing.small};
`;

export const FinalStepWrapper = styled.div`
  gap: ${spacing.mediumLow};
  display: flex;
  flex-direction: column;
`;

export const CheckboxLabel = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Divider = styled.div`
  box-sizing: border-box;
  border-bottom: 2px solid ${colors.monochrome.grey20};
  margin-bottom: ${spacing.xsmall};
`;

export const OrderSummaryDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Label = styled.div<{ color?: string }>`
  ${typography.body.large};
  margin-bottom: ${spacing.tiny};
  color: ${({ color }) => color ?? colors.primary.grey};
`;

export const OrderDetailsValue = styled.div`
  ${typography.body.large};
  margin-bottom: ${spacing.tiny};
`;
